import React from "react";
import {
  ChevronUp,
  Edit,
  Eye,
  RotateCcw,
  Trash2,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { all_routes } from "../../../../Router/all_routes";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Table from "../../../../core/pagination/datatable";
import { setToogleHeader } from "../../../../core/redux/action";

const Applicants = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.applicant_tracking_applicants_data
  );
  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.toggle_header);

  const route = all_routes;

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name?.length - b.Name?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text) => {
        console.log("Status Data:", text); // Debugging output

        const isActive = String(text)?.toLowerCase() === "active"; // Ensure it's a string

        return (
          <div className="d-flex justify-content-center">
            <span className={`badge ${isActive ? "bg-success" : "bg-danger"}`}>
              {isActive ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
      sorter: (a, b) =>
        (String(a.Status)?.length || 0) - (String(b.Status)?.length || 0),
    },
    {
      title: "Role",
      dataIndex: "Role",
      sorter: (a, b) => a.Role?.length - b.Role?.length,
    },

    {
      title: "Locations",
      dataIndex: "Locations",
      sorter: (a, b) => a.Locations.length - b.Locations.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Education",
      dataIndex: "Education",
      sorter: (a, b) => a.Education.length - b.Education.length,
    },
    {
      title: "Skills",
      dataIndex: "Skills", // Correct field name
      sorter: (a, b) => (a.Skills?.length || 0) - (b.Skills?.length || 0),
      render: (skills) => {
        if (!Array.isArray(skills) || skills.length === 0) return "-";

        const skillString = skills.join(", "); // Convert array to string

        return skillString.length > 15
          ? `${skillString.substring(0, 15)}...`
          : skillString;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="/applicantTracking/editapplicant"
                className="dropdown-item"
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>
            <li>
              <Link
                to="/applicantTracking/editapplicant"
                className="dropdown-item"
              >
                <Edit className="info-img" />
                Edit
              </Link>
            </li>
            <li>
              <Link
                to="/applicantTracking/editapplicant"
                className="dropdown-item"
              >
                <Calendar className="info-img" />
                Schedule Interview
              </Link>
            </li>
            <li>
              <Link className="dropdown-item mb-0">
                <Trash2 className="info-img" />
                Delete
              </Link>
            </li>
          </ul>
        </>
      ),
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Applicants List
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Applicants here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to={route.applicanttrackingaddapplicant}
              className="btn btn-primary"
            >
              <i className="ti ti-circle-plus me-1"></i>
              New Applicant
            </Link>
          </div>
          {/* <div className="page-btn import">
            <Link
              to="#"
              className="btn btn-secondary color"
              //   data-bs-toggle="modal"
              //   data-bs-target="#view-notes"
            >
              <Download className="feather me-2" />
              Import Product
            </Link>
          </div> */}
        </div>
        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-secondary">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">88,798</h4>
                    <p>Total Applicants</p>
                  </div>
                  <span className="revenue-icon bg-cyan-transparent text-cyan">
                    <i className="fa-solid fa-layer-group fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-success">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">8,878</h4>
                    <p>Active Applicants</p>
                  </div>
                  <span className="revenue-icon bg-teal-transparent text-teal">
                    <i className="ti ti-chart-pie fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-danger">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">97</h4>
                    <p>Inactive Applicants</p>
                  </div>
                  <span className="revenue-icon bg-orange-transparent text-orange">
                    <i className="ti ti-lifebuoy fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="card revenue-widget flex-fill border border-info">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="mb-1">98</h4>
                    <p>Recently Posted Applicants</p>
                  </div>
                  <span className="revenue-icon bg-indigo-transparent text-indigo">
                    <i className="ti ti-hash fs-16" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Company
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      GlobalCorp Industries
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      TechNova Solutions
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Apex Innovations
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Woodcraft Sandal
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Status
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      All
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Active
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Inactive
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Location
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      South Africa
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      India
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Germany
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      USA
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Applicants;
